import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-brand">
                    <img src="/logo.png" alt="Brand Logo" className="footer-brand-logo" />
                    <div className="footer-brand-info">
                        <h4 className="footer-brand-name">Nisha's Dental Care</h4>
                        <p className="footer-brand-about">Your smile is our priority!</p>
                    </div>
                </div>
                <div className="footer-contact">
                    <div className="footer-address">
                        <i className="footer-icon fas fa-map-marker-alt"></i>
                        <p>Borjhar, VIP-Chowk</p>
                    </div>
                    <div className="footer-phone">
                        <i className="footer-icon fas fa-phone-alt"></i>
                        <a href="tel:+919101067477">(+91) 9101067477</a>
                    </div>
                </div>
                <div className="footer-links">
                    <h4 className="footer-links-heading">Quick Links</h4>
                    <ul className="footer-links-list">
                        <li><Link to="/">Home</Link></li>
                        <li><Link to="/services">Services</Link></li>
                        <li><Link to="/about">About</Link></li>
                        <li><Link to="/contact">Contact</Link></li>
                    </ul>
                </div>
                <div className="footer-social">
                    <h4 className="footer-social-heading">Follow Us</h4>
                    <div className="footer-social-icons">
                        <a href="https://www.facebook.com/matu8oct/" target='_blank'><i className="footer-icon fab fa-facebook"></i></a>
                       
                        <a href="https://www.instagram.com/drnisha.talukdar/" target='_blank'><i className="footer-icon fab fa-instagram"></i></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
